"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.storesContext = void 0;
var react_1 = __importDefault(require("react"));
var UserStore_1 = __importDefault(require("stores/UserStore"));
var ProductsStore_1 = __importDefault(require("stores/ProductsStore"));
var ProductPageStore_1 = __importDefault(require("../stores/ProductPageStore"));
var PrefsStore_1 = __importDefault(require("../stores/PrefsStore"));
var ProductCategoriesStore_1 = __importDefault(require("../stores/ProductCategoriesStore"));
var ProductSubCategoriesStore_1 = __importDefault(require("../stores/ProductSubCategoriesStore"));
var OrdersStore_1 = __importDefault(require("../stores/OrdersStore"));
var OrderPageStore_1 = __importDefault(require("../stores/OrderPageStore"));
var DeliveryStore_1 = __importDefault(require("../stores/DeliveryStore"));
var CustomerAccountStore_1 = __importDefault(require("../stores/CustomerAccountStore"));
var ProductSpecsStore_1 = __importDefault(require("../stores/ProductSpecsStore"));
var ProductOptionsStore_1 = __importDefault(require("../stores/ProductOptionsStore"));
var ApiStore_1 = __importDefault(require("../stores/ApiStore"));
exports.storesContext = react_1.default.createContext({
    apiStore: ApiStore_1.default,
    userStore: UserStore_1.default,
    productsStore: ProductsStore_1.default,
    productPageStore: ProductPageStore_1.default,
    productCategoriesStore: ProductCategoriesStore_1.default,
    productSubCategoriesStore: ProductSubCategoriesStore_1.default,
    productSpecsStore: ProductSpecsStore_1.default,
    productOptionsStore: ProductOptionsStore_1.default,
    ordersStore: OrdersStore_1.default,
    orderPageStore: OrderPageStore_1.default,
    deliveryStore: DeliveryStore_1.default,
    customerAccountStore: CustomerAccountStore_1.default,
    prefsStore: PrefsStore_1.default
});
